import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { FacilitiesoverviewRoutingModule } from './facilitiesoverview-routing.module';
import { FacilitiesListComponent } from './facilities-list/facilities-list.component';
import { FacilitiesCreateComponent } from './facilities-create/facilities-create.component';

@NgModule({
  declarations: [FacilitiesListComponent, FacilitiesCreateComponent],
  imports: [
    CommonModule,
    FacilitiesoverviewRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class FacilitiesoverviewModule { }
